"use strict";

exports.__esModule = true;
exports.TimeWrapper = exports.MutedText = exports.DurationWrapper = exports.CycleListItemColor = exports.CycleListItemButtonHeader = exports.CycleListItemButtonBody = exports.CycleListItemButton = exports.CycleListItemBody = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = require("../../Core/Text");
var _Theme = require("../../Theme");
var _PlantStateActivities = require("../../PlantStateActivities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// eslint-disable-next-line

var MONO = 'ui-monospace, Menlo, Consolas, "DejaVu Sans Mono", monospace';
var CycleListItemButton = exports.CycleListItemButton = _styledComponents["default"].button.withConfig({
  displayName: "CycleListStylingmodern__CycleListItemButton",
  componentId: "sc-11qvw9h-0"
})(["outline:none;cursor:pointer;box-sizing:border-box;text-align:left;border-style:none;border-bottom:#eff2f4 solid 1px;padding:0;color:", ";background:", ";display:flex;min-height:96px;touch-action:manipulation;-webkit-tap-highlight-color:transparent;&:hover{background:#f8fafb;}"], (0, _Theme.selectable)("CycleListItemColor"), (0, _Theme.selectable)("CycleListItemBackground"));
var CycleListItemColor = exports.CycleListItemColor = _styledComponents["default"].div.withConfig({
  displayName: "CycleListStylingmodern__CycleListItemColor",
  componentId: "sc-11qvw9h-1"
})(["background:", ";flex:0 0 8px;margin:12px 0 12px 12px;height:72px;border-radius:3px;div{position:relative;top:70%;background:rgba(0,0,0,0.25);height:30%;border-radius:0 0 2px 2px;}"], function (_ref) {
  var state = _ref.state,
    theme = _ref.theme;
  return (0, _PlantStateActivities.getPlantStateColor)(theme, state.id);
});
var CycleListItemBody = exports.CycleListItemBody = _styledComponents["default"].div.withConfig({
  displayName: "CycleListStylingmodern__CycleListItemBody",
  componentId: "sc-11qvw9h-2"
})(["flex:1;min-width:0;height:96px;padding:16px 40px 16px 14px;position:relative;&::after{content:\"\u203A\";position:absolute;right:16px;top:50%;transform:translateY(-55%);font-size:24px;line-height:1;color:#b9c4cb;}"]);
var CycleListItemButtonHeader = exports.CycleListItemButtonHeader = (0, _styledComponents["default"])(_core.Text).withConfig({
  displayName: "CycleListStylingmodern__CycleListItemButtonHeader",
  componentId: "sc-11qvw9h-3"
})(["width:100%;font-size:17px;font-weight:", ";color:#1b2227;margin-bottom:5px;"], (0, _Theme.val)("fontWeightHeavy"));
var TimeWrapper = exports.TimeWrapper = (0, _styledComponents["default"])(_core.Text).withConfig({
  displayName: "CycleListStylingmodern__TimeWrapper",
  componentId: "sc-11qvw9h-4"
})(["width:100%;font-family:", ";font-size:13.5px;color:#5a6771;margin-bottom:3px;"], MONO);
var DurationWrapper = exports.DurationWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CycleListStylingmodern__DurationWrapper",
  componentId: "sc-11qvw9h-5"
})(["width:100%;font-family:", ";font-size:13.5px;"], MONO);
var MutedText = exports.MutedText = (0, _styledComponents["default"])(_Text.Text).withConfig({
  displayName: "CycleListStylingmodern__MutedText",
  componentId: "sc-11qvw9h-6"
})(["color:", ";"], (0, _Theme.val)("mutedColor"));
var CycleListItemButtonBody = exports.CycleListItemButtonBody = _styledComponents["default"].div.withConfig({
  displayName: "CycleListStylingmodern__CycleListItemButtonBody",
  componentId: "sc-11qvw9h-7"
})([""]);